<template>
  <page-layout
    :breadcrumbs="[
      {
        text: 'HOME',
        disabled: true,
        exact: true
      }
    ]"
  >
    <v-container class="pt-0">
      <v-row class="pt-0">
        <v-col cols="12" md="9" class="pt-0">
          <v-row class="pt-0">
            <v-col cols="12" class="pt-0">
              <v-row no-gutters justify="center">
                <!-- eslint-disable-next-line -->
                <span class="text-h5 viralYellow--text" style="font-weight: bold">CATEGORÍAS</span>
              </v-row>
            </v-col>
            <v-col v-for="(categoria, i) in categorias" :key="categoria.id" cols="6">
              <v-card @click="clickCategoria(categoria.id)" class="pointer">
                <v-row no-gutters>
                  <v-col cols="12" :ref="'categoriaImg-' + i">
                    <v-img
                      :src="categoria.src"
                      style="border-top-left-radius: 5px;border-top-right-radius: 5px"
                      :width="categoriaWidth"
                      :height="categoriaHeight"
                    />
                  </v-col>
                  <v-col cols="12" class="mt-2 mb-3 ml-3">
                    <span class="viralYellow--text text-subtitle-1 text-md-h6" style="font-weight: bold">
                      {{ categoria.nombre }}
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          xs="12"
          md="3"
          class="pt-md-0"
          :style="$vuetify.breakpoint.smAndDown ? 'border-top: solid #FBF000 2px;' : ''"
        >
          <v-row justify="center" class="pt-md-0">
            <v-col cols="12" class="pt-md-0">
              <v-row no-gutters justify="center" class="pt-md-0">
                <!-- eslint-disable-next-line -->
                <span class="text-h5 viralYellow--text" style="font-weight: bold">TOP VÍDEOS</span>
              </v-row>
            </v-col>
          </v-row>
          <v-row :style="$vuetify.breakpoint.mdAndUp ? 'border-left: solid #FBF000 2px;' : ''">
            <v-col v-for="(video, i) in videosTop" :key="video.id" cols="12">
              <v-card
                color="primary-darken-1"
                @click="clickVideo(video.id, video.categoriaId)"
                class="pointer"
                style="border-radius: 5px"
              >
                <v-row no-gutters>
                  <v-col cols="12" :ref="'videoImg-' + i">
                    <v-img
                      :src="video.src"
                      style="border-top-left-radius: 5px;border-top-right-radius: 5px"
                      :width="videoTopWidth"
                      :height="videoTopHeight"
                    />
                  </v-col>
                  <v-col cols="12" class="pt-2 pb-3 px-2 px-md-1 px-lg-2" style="min-height: 66px">
                    <span class="text-xs-subtitle-2 text-md-caption text-lg-subtitle-2">
                      {{ video.nombre }}
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </page-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'home',
  data() {
    return {
      categoriaWidth: 0,
      videoTopWidth: 0
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.categoriaWidth = this.$refs['categoriaImg-0'][0].clientWidth
    this.videoTopWidth = this.$refs['videoImg-0'][0].clientWidth
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    ...mapGetters({
      getAllCategorias: 'viralmobile/getAllCategorias',
      getAllVideos: 'viralmobile/getAllVideos'
    }),
    categorias() {
      return this.getAllCategorias.map(x => {
        return {
          id: x.id,
          nombre: x.nombre.toUpperCase(),
          src: require('@/assets/images/categorias/' + x.imagen)
        }
      })
    },
    videosTop() {
      if (this.loadingData) return []
      let retorno = this.getAllVideos
        .map(x => {
          return {
            ...x,
            src: require('@/assets/images/videos/' + x.imagen)
          }
        })
        .sort(() => 0.5 - Math.random())
      return retorno.slice(0, 6)
    },
    categoriaHeight() {
      return this.categoriaWidth / 1.7778
    },
    videoTopHeight() {
      return this.videoTopWidth / 1.7778
    }
  },
  methods: {
    onResize() {
      this.categoriaWidth = this.$refs['categoriaImg-0'][0].clientWidth
      this.videoTopWidth = this.$refs['videoImg-0'][0].clientWidth
    },
    clickCategoria(id) {
      this.$router.push({ name: 'category', params: { id: id } })
    },
    clickVideo(id, categoriaId) {
      this.$router.push({
        name: 'video',
        params: { categoriaId: categoriaId, videoId: id }
      })
    }
  }
}
</script>
